module.exports = __webpack_public_path__ + "static/media/img11.09027558.jpg";